<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" @load="load" @reset="reset"
                 title="Lĩnh vực" titleIcon="fa fa-cubes">
            <template slot="filter">
            </template>
            <template slot="action">
                <g-button  v-if="permissions('public-service-field_create')"  :loading="saveLoading" size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(name)="{item}">
                <span :class="(item.blocked ? 'c-signal' : 'c-signal is-success')"><span class="h-word-break">{{item.name}}</span></span>
            </template>
            <template #cell(post_count)="{item}">
                <div v-if="params.post_count[item.id]" >
                    <span> {{ params.post_count[item.id].c }}</span>
                </div>
            </template>
            <template #cell(template)="{item}">
                <div v-if="item.template && $params.post.templateOptions.find(o => o.value == item.template)">{{$params.post.templateOptions.find(o => o.value == item.template).text}}</div>
            </template>
            <template #cell(banner)="{item}">
                <div v-if="item.banner && params.files[item.banner]" >
                    <img :src="params.files[item.banner].url" class="rounded-circle img-thumbnail" style="width:50px; height: 50px">
                </div>
            </template>
            <template #cell(action)="{item}">
                <g-button v-if="permissions('public-service-field_update')" :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('public-service-field_del')" :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <!-- <form-select :disabled="formModel.id" label="Danh mục cha" :model="formModel" attribute="parent_id" :errors="formErrors" :options="catOptions" desc="Danh mục khác với thẻ, bạn có thể sử dụng nhiều cấp danh mục. Ví dụ: Trong danh mục nhạc, bạn có danh mục con là nhạc Pop, nhạc Jazz. Việc này hoàn toàn là tùy theo ý bạn. Hỗ trợ tối đa 3 cấp cha-con"></form-select> -->
            <form-input label="Tên lĩnh vực" :required='true' :model="formModel" attribute="name" :errors="formErrors" desc="Tên riêng sẽ hiển thị trên website" />
            <form-input label="Đường dẫn" :required='true' :model="formModel" attribute="slug" :errors="formErrors" desc="Chuỗi cho đường dẫn tĩnh là phiên bản của tên hợp chuẩn với Đường dẫn (URL). Chuỗi này bao gồm chữ cái thường, số và dấu gạch ngang (-)." />
            <!-- <form-select label="Template hiển thị" :model="formModel" attribute="template" :errors="formErrors" :options="$params.post.templateOptions" desc=""></form-select> -->
            <form-input label="Thứ tự" :model="formModel" attribute="position" :errors="formErrors" />
            <!-- <form-textarea label="Mô tả" :model="formModel" :errors="formErrors" attribute="desc" desc="Mô tả không được sử dụng trên website" /> -->
            <!-- <form-media label="Ảnh banner" :model="formModel" attribute="banner" placeholder="Chọn ảnh banner" /> -->
            <form-checkbox chk-label="Tạm ẩn trên website" :model="formModel" :errors="formErrors"  attribute="blocked" />

            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    // import FormMedia from '@/components/media/FormMedia';

    export default {
        components: {},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadCategory",
                service: '/public-service-field',
                fields: [
                    {key: 'name', label: "Tên danh mục", class: 'text-left'},
                    {key: 'position', label: "#", class: 'text-center'},
                    {key: 'post_count', label: "Số bài viết", class: 'text-right'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    size: 1000000, //Mặc định hiển thị toàn bộ
                    keyword: '',
                },
                defaultFormModel: {
                    parent_id: 0,
                    name: null,
                    slug: null,
                    blocked: null,
                    template: null
                },
                catOptions: [{value: 0, text: "Trống"}],
            }

        },
        watch: {
            "formModel.name": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.slug": {
                handler(val) {
                    if (val) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            }
        },
        methods: {
           
        },
        mounted() {
        }
    }
</script>